import React from "react";
import Modal from "components/modal";
import Button from "components/button";
import { useDispatch, useSelector } from "react-redux";
import LoaderButton from "components/button/LoaderButton";
import { reverseSplitOrderItem } from "store/orderSlice";

function RevertItemModal({ isOpen, onClose, item, refreshList }) {
  const dispatch = useDispatch();
  const { reverseSplitOrderItemError, reverseSplitOrderItemLoading } =
    useSelector((state) => state.orders);

  const handleRevert = async () => {
    try {
      const response = await dispatch(
        reverseSplitOrderItem({
          childItemId: item?._id,
        })
      );

      if (
        response?.payload?.statuscode === 200 ||
        response?.payload?.statuscode === 201
      ) {
        refreshList?.();
        onClose();
      } else {
        console.error("Revert failed:", response?.payload?.msg);
      }
    } catch (error) {
      console.error("Revert failed:", error);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} className="max-w-lg">
      <h2 className="border-b py-3 pl-2 text-xl font-bold text-navy-700 dark:text-white">
        Revert Item
      </h2>

      <div className="p-4">
        {/* Product details */}
        <div className="flex items-start gap-4 border p-2 rounded-md">
          <img
            src={item?.picture || item?.orderItem?.picture}
            alt={item?.name || "Product"}
            className="h-20 w-20 rounded-md border object-cover"
          />
          <div className="flex flex-col justify-center">
            <p className="text-lg font-semibold text-navy-700 dark:text-white">
              {item?.name || "Unnamed Item"}
            </p>
            <p className="text-sm text-gray-600 dark:text-gray-300">
              {item?.description || "No description"}
            </p>
            <p className="mt-1 text-sm text-navy-700 dark:text-white">
              Total Quantity: <strong>{item?.totalQty || 0}</strong>
            </p>
          </div>
        </div>

        <p className="mt-4 text-gray-600 dark:text-gray-300">
          Are you sure you want to revert this split?
        </p>

        {/* Error message */}
        {reverseSplitOrderItemError && (
          <p className="mt-2 text-sm text-red-500">
            {reverseSplitOrderItemError}
          </p>
        )}

        <div className="mt-6 flex justify-end gap-3">
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <LoaderButton
            isLoading={reverseSplitOrderItemLoading}
            onClick={handleRevert}
          >
            Revert
          </LoaderButton>
        </div>
      </div>
    </Modal>
  );
}

export default RevertItemModal;
